<template>
  <div class="version">
    App Version: {{ $brgGlobal.VUE_APP_VERSION }}
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss" scoped>
.version {
  position: absolute;
  bottom: 5px;
  left: 10px;
  font-size: 12px;
  color: #333;
  z-index: $z-index-app-version;
}
</style>
